var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  YayoyakiValue: () => YayoyakiValue
});
var import_yayoyakiCannotHaveValue = __toModule(require("../error/yayoyakiCannotHaveValue"));
var import_definition2 = __toModule(require("./definition"));
var import_yayoyakiFormatter = __toModule(require("./yayoyakiFormatter"));
var import_yayoyakiValidator = __toModule(require("./yayoyakiValidator"));
class YayoyakiValue {
  constructor(samaData, samaForm, yayoyakiForm, index) {
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.yayoyakiForm = yayoyakiForm;
    this.index = index;
    this.validateCategory(yayoyakiForm);
    this.validateId(yayoyakiForm);
    this.validateMatrix(yayoyakiForm);
    this.validateValidationType(yayoyakiForm);
    if (this.isMatrix() && index === void 0) {
      throw new Error(`${yayoyakiForm.id} is matrix but index is undefined.`);
    }
  }
  validateCategory(yayoyakiForm) {
    if (!yayoyakiForm.category) {
      throw new Error(`${yayoyakiForm.id} does not have category.`);
    }
    if (yayoyakiForm.category !== "data" && yayoyakiForm.category !== "visual") {
      throw new Error(`${yayoyakiForm.id} has invalid category ${yayoyakiForm.category}.`);
    }
  }
  validateId(yayoyakiForm) {
    if (yayoyakiForm.id === void 0) {
      throw new Error(`Invalid yayoyaki, does not have id.`);
    }
  }
  validateMatrix(yayoyakiForm) {
    if (yayoyakiForm.matrix === void 0) {
      throw new Error(`${yayoyakiForm.id} does not have matrix.`);
    }
  }
  validateValidationType(yayoyakiForm) {
    if (!yayoyakiForm.validationType) {
      throw new Error(`${yayoyakiForm.id} does not have validationType.`);
    }
  }
  evaluateSafe(expression) {
    try {
      const value = import_yayoyakiValidator.YayoyakiValidator.evaluateExpression(this.samaData.getUserData(), expression);
      if (this.isMatrix()) {
        return value[this.index];
      }
      return value;
    } catch (e) {
      return this.getDefaultValue();
    }
  }
  requirementSafe(expression) {
    try {
      return import_yayoyakiValidator.YayoyakiValidator.validateRequirements(this.samaData.getUserData(), expression, this.index);
    } catch (e) {
      return true;
    }
  }
  static getId(yayoyakiForm) {
    return yayoyakiForm.id;
  }
  static isVisual(yayoyakiForm) {
    return yayoyakiForm.category === "visual";
  }
  getOptions() {
    if (!this.yayoyakiForm.optionsId && !this.yayoyakiForm.optionsCalculation) {
      return;
    }
    if (this.yayoyakiForm.optionsCalculation) {
      const valueExpression = import_yayoyakiValidator.YayoyakiValidator.validateRequirements(this.samaData.getUserData(), this.yayoyakiForm.optionsCalculation);
      return valueExpression.filter((it) => it !== void 0).map((it) => ({ label: it, value: it }));
    }
    const newOptions = [];
    for (const optionId of this.yayoyakiForm.optionsId) {
      const option = this.samaForm.getOptionsForm(optionId);
      if (option.requirement) {
        if (this.requirementSafe(option.requirement)) {
          newOptions.push({ label: option.label, value: option.value });
        }
      } else {
        newOptions.push({ label: option.label, value: option.value });
      }
    }
    return newOptions;
  }
  isRequirement() {
    if (!this.yayoyakiForm.requirement) {
      return true;
    }
    return this.requirementSafe(this.yayoyakiForm.requirement);
  }
  getDefaultValue() {
    const yayoyakiForm = __spreadProps(__spreadValues({}, this.yayoyakiForm), {
      options: this.getOptions()
    });
    return import_yayoyakiValidator.YayoyakiValidator.getFieldDefault(yayoyakiForm);
  }
  isDefaultValue() {
    const value = this.getValue();
    const yayoyakiForm = __spreadProps(__spreadValues({}, this.yayoyakiForm), {
      options: this.getOptions()
    });
    return import_yayoyakiValidator.YayoyakiValidator.isFieldDefault(value, yayoyakiForm);
  }
  getConditionError() {
    var _a, _b;
    const expression = (_b = (_a = this.yayoyakiForm) == null ? void 0 : _a.condition) == null ? void 0 : _b.expression;
    if (!expression) {
      return;
    }
    if (!this.requirementSafe(expression)) {
      return this.yayoyakiForm.condition.text;
    }
  }
  getValidationError() {
    var _a;
    const conditionError = this.getConditionError();
    if (conditionError) {
      return conditionError;
    }
    const value = this.getValue();
    const yayoyakiForm = __spreadProps(__spreadValues({}, this.yayoyakiForm), {
      options: this.getOptions()
    });
    if (!import_yayoyakiValidator.YayoyakiValidator.isFieldValid(value, yayoyakiForm)) {
      if (!((_a = this.yayoyakiForm.validations) == null ? void 0 : _a.required) && this.getValue() === void 0) {
        return;
      }
      return import_yayoyakiValidator.YayoyakiValidator.getFieldValidationMessage(value, yayoyakiForm);
    }
  }
  isCompletion() {
    if (this.yayoyakiForm.completionExpression && this.yayoyakiForm.completionLabel) {
      return true;
    }
    return false;
  }
  getLabel() {
    if (this.isCompletion()) {
      return this.isCompleted() ? this.yayoyakiForm.completionLabel : this.yayoyakiForm.label;
    }
    return this.yayoyakiForm.label;
  }
  getLabelCard() {
    return this.yayoyakiForm.labelCard;
  }
  isCompleted() {
    if (!this.yayoyakiForm.completionExpression || !this.yayoyakiForm.completionLabel) {
      throw new Error(`${this.yayoyakiForm.id} is not a completion yayoyaki, invalid call`);
    }
    return !!this.evaluateSafe(this.yayoyakiForm.completionExpression);
  }
  getValue(initial = false) {
    if (this.yayoyakiForm.valueExpression) {
      return this.evaluateSafe(this.yayoyakiForm.valueExpression);
    }
    if (this.isMatrix()) {
      return this.samaData.getValueMatrix(this.yayoyakiForm.id, this.index, initial);
    }
    return this.samaData.getValueScalar(this.yayoyakiForm.id, initial);
  }
  getRenderValue() {
    var _a;
    const value = this.getValue();
    const options = this.getOptions();
    if (options) {
      return (_a = options.find((option) => option.value === value)) == null ? void 0 : _a.label;
    }
    return import_yayoyakiFormatter.YayoyakiFormatter.hasFormatter(value, this.yayoyakiForm.type) ? import_yayoyakiFormatter.YayoyakiFormatter.formatValue(value, this.yayoyakiForm.type) : value;
  }
  getCategory() {
    return this.yayoyakiForm.category;
  }
  getId() {
    return YayoyakiValue.getId(this.yayoyakiForm);
  }
  getRenderForm() {
    var _a, _b, _c;
    if (!this.isRequirement()) {
      return;
    }
    const editability = this.editability();
    const result = {
      helpButtonUrl: this.yayoyakiForm.helpButtonUrl,
      imageUrl: this.yayoyakiForm.imageUrl,
      description: this.yayoyakiForm.info,
      label: this.getLabel(),
      placeholder: this.yayoyakiForm.placeholder,
      isCompleted: this.isCompletion() ? this.isCompleted() : void 0,
      type: this.yayoyakiForm.type,
      validations: this.yayoyakiForm.validations,
      validationType: (_a = this.yayoyakiForm) == null ? void 0 : _a.validationType,
      options: this.getOptions(),
      valueRender: this.getRenderValue(),
      value: this.getValue(),
      editability,
      readOnly: editability === import_definition2.Editability.READONLY,
      isDirty: this.isDirty(),
      hasWarning: editability === import_definition2.Editability.WARNING,
      isMandatory: (_c = (_b = this.yayoyakiForm) == null ? void 0 : _b.validations) == null ? void 0 : _c.required,
      warningMsg: this.yayoyakiForm.warningMsg
    };
    if (this.yayoyakiForm.nest) {
      result.style = { marginVertical: 10, marginLeft: this.yayoyakiForm.nest ? 10 : 0 };
    }
    const validationError = this.getValidationError();
    if (validationError) {
      result.error = validationError;
    }
    return result;
  }
  isMatrix() {
    return this.yayoyakiForm.matrix;
  }
  editability() {
    const editability = this.yayoyakiForm.editability;
    if (import_definition2.Editability.FREE === editability || import_definition2.Editability.READONLY === editability && !this.isValid()) {
      return import_definition2.Editability.FREE;
    }
    if (!this.isMatrix()) {
      if (this.samaData.getUserDataInitial()[this.getId()] === void 0) {
        return import_definition2.Editability.FREE;
      }
      return editability;
    }
    const groupYayoyakiIdentifierId = this.getYayoyakiGroupIdentifierId();
    if (!groupYayoyakiIdentifierId) {
      return import_definition2.Editability.FREE;
    }
    const groupYayoyakiIdentifier = this.samaData.getValue(groupYayoyakiIdentifierId);
    const groupYayoyakiIdentifierInitial = this.samaData.getValue(groupYayoyakiIdentifierId, true);
    if (!groupYayoyakiIdentifierInitial) {
      return import_definition2.Editability.FREE;
    }
    const value = groupYayoyakiIdentifier[this.index];
    const sameIdentifierFound = groupYayoyakiIdentifierInitial.includes(value);
    if (sameIdentifierFound) {
      return editability;
    }
    return import_definition2.Editability.FREE;
  }
  isDirty() {
    var _a;
    const value = this.getValue();
    if (!this.isMatrix()) {
      return value !== this.samaData.getUserDataInitial()[this.getId()] && value !== this.getDefaultValue();
    }
    const groupYayoyakiIdentifierId = this.getYayoyakiGroupIdentifierId();
    if (!groupYayoyakiIdentifierId)
      return value !== this.getDefaultValue();
    const groupYayoyakiIdentifierValues = this.samaData.getValue(groupYayoyakiIdentifierId);
    const groupYayoyakiIdentifierValuesInitial = this.samaData.getValue(groupYayoyakiIdentifierId, true);
    const indexGroup = groupYayoyakiIdentifierValuesInitial == null ? void 0 : groupYayoyakiIdentifierValuesInitial.findIndex((yayoValue) => yayoValue === groupYayoyakiIdentifierValues[this.index]);
    if (indexGroup < 0)
      return value !== this.getDefaultValue();
    return value !== ((_a = this.samaData.getUserDataInitial()[this.getId()]) == null ? void 0 : _a[indexGroup]) && value !== this.getDefaultValue();
  }
  getYayoyakiGroupIdentifierId() {
    const yayoyakiMap = this.samaForm.getYayoyakiMap();
    const matrixGroupYayoyakiIds = Object.keys(yayoyakiMap).filter((yayoyakiId) => yayoyakiMap[yayoyakiId].matrixGroup === this.yayoyakiForm.matrixGroup);
    return matrixGroupYayoyakiIds.find((id) => yayoyakiMap[id].isMatrixGroupIdentifier);
  }
  isValid() {
    if (!this.isRequirement()) {
      return true;
    }
    return !this.getValidationError();
  }
  isData() {
    return this.getCategory() === "data";
  }
  isVisual() {
    return YayoyakiValue.isVisual(this.yayoyakiForm);
  }
  setValue(value) {
    if (this.isVisual()) {
      throw new import_yayoyakiCannotHaveValue.YayoyakiCannotHaveValue(this.getId());
    }
    this.samaData.setValue(this.getId(), value, this.isMatrix() ? this.index : void 0);
  }
  clean() {
    if (!this.isVisual() && !this.isRequirement()) {
      this.setValue(this.getDefaultValue());
    }
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  YayoyakiValue
});
